// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"8f9c4b72","419":"b8d2f757","425":"ac9eb12c","745":"e3b04f8e","884":"01611433"}[chunkId] + ".chunk.css";
};